"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeartBeatEvent = exports.createWebLogEvent = exports.createMetadata = void 0;
var fingerprintjs_1 = require("@fingerprintjs/fingerprintjs");
var moment = require("moment");
var uuid_1 = require("uuid");
var helpers_1 = require("../helpers");
var types_1 = require("../types");
var storage_service_1 = require("./storage-service");
var _ = require("lodash");
var getClientInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var fp, client_result, components, language, platform, timezone, resolution, cookies, visitor_id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fingerprintjs_1.default.load()];
            case 1:
                fp = _a.sent();
                return [4 /*yield*/, fp.get()];
            case 2:
                client_result = _a.sent();
                components = client_result.components;
                language = '';
                if (components.languages.value.length > 0) {
                    language = components.languages.value[0][0];
                }
                platform = components.platform.value;
                timezone = components.timezone.value;
                resolution = components.screenResolution.value;
                cookies = components.cookiesEnabled.value ? document.cookie : '';
                visitor_id = storage_service_1.TrackingStorage.INSTANCE.getField('vid');
                if (!visitor_id) {
                    visitor_id = client_result.visitorId;
                    storage_service_1.TrackingStorage.INSTANCE.setField('vid', visitor_id);
                }
                return [2 /*return*/, [
                        {
                            charset: 'UTF-8',
                            clientCookies: cookies,
                            ds: "".concat(window.innerWidth, "x").concat(window.innerHeight),
                            language: language,
                            offset: moment().utc().local().format('Z'),
                            platform: platform,
                            tz: timezone,
                            res: "".concat(resolution[0], "x").concat(resolution[1]),
                        },
                        visitor_id,
                    ]];
        }
    });
}); };
var createMetadata = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, client_info, visitor_id, metadata;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getClientInfo()];
            case 1:
                _a = _b.sent(), client_info = _a[0], visitor_id = _a[1];
                metadata = {
                    client: client_info,
                    visitor: {
                        visitorId: visitor_id,
                    },
                };
                if (options === null || options === void 0 ? void 0 : options.address) {
                    metadata.visitor.address = options.address;
                }
                return [2 /*return*/, metadata];
        }
    });
}); };
exports.createMetadata = createMetadata;
var createWebLogEvent = function (id, type, name) {
    return function (sub_schema, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, client_info, visitor_id, current, payload, event;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getClientInfo()];
                case 1:
                    _a = _b.sent(), client_info = _a[0], visitor_id = _a[1];
                    current = moment().utc().unix();
                    payload = _.omitBy(__assign(__assign({}, sub_schema), { createdAt: current, eventId: (0, uuid_1.v4)(), eventType: type, eventName: name }), _.isUndefined);
                    event = {
                        client: client_info,
                        event: {
                            id: id,
                            payload: JSON.stringify(payload),
                        },
                        visitor: {
                            visitorId: visitor_id,
                        },
                        hash: (0, helpers_1.createObjectHash)(payload),
                    };
                    if (options === null || options === void 0 ? void 0 : options.address) {
                        event.visitor.address = options.address;
                    }
                    return [2 /*return*/, event];
            }
        });
    }); };
};
exports.createWebLogEvent = createWebLogEvent;
var createHeartBeatEvent = function (href) {
    return function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, client_info, visitor_id, payload, event;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getClientInfo()];
                case 1:
                    _a = _b.sent(), client_info = _a[0], visitor_id = _a[1];
                    payload = _.omitBy({
                        href: href,
                        createdAt: moment().utc().unix(),
                        eventId: (0, uuid_1.v4)(),
                        eventType: 'heartBeatEvent',
                        eventName: 'heartBeat',
                    }, _.isUndefined);
                    event = {
                        client: client_info,
                        visitor: {
                            visitorId: visitor_id,
                        },
                        event: {
                            id: types_1.EventId.HeartBeat,
                            payload: JSON.stringify(payload),
                        },
                        hash: (0, helpers_1.createObjectHash)(payload),
                    };
                    if (options === null || options === void 0 ? void 0 : options.address) {
                        event.visitor.address = options.address;
                    }
                    return [2 /*return*/, event];
            }
        });
    }); };
};
exports.createHeartBeatEvent = createHeartBeatEvent;
